module.exports = "/virtual-football-league/img/amblems/left/Germany/Fake_Leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Germany/Fake_Leverkusen.png
// module id = 2037
// module chunks = 4